<template>
 <v-container background fluid pa-3 v-scroll="onScrollFunction" class="contain_width">
    <div id="search_box" class="searching_box">
      <v-text-field
        v-show="show_search"
        name="search_item"
        v-model="Search_data"
        @input="searchProcess()"
        label="ค้นหา..."
        style="margin-top:7px;color:#fff"
        flat
        color="white"
        class="search_text"
        append-icon
        clearable
      />
    </div>

 <filter-component :json_data ="form_dialog_data" v-on:set="onCloseFormDialog" />

    <v-btn slot="activator" icon @click="searchClick()" class="btn_show_search">
      <v-icon :size="16">fa-search</v-icon>
    </v-btn>

     <v-btn slot="activator" icon @click="showFilter(true)" class="btn_show_filter">
      <v-icon :size="16">fa-filter</v-icon>
    </v-btn>

    <v-layout row wrap hidden-xs-only>
      <v-flex xs12 sm12 class="search_in_page_flex">
        <v-text-field
          solo
          label="ค้นหา..."
          v-model="Search_data"
          @input="searchProcess()"
          append-icon="search"
          style="margin-bottom: 0px;"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap hidden-xs-only>
      <v-flex xs12 sm12 class="search_in_page">
        <v-text-field
          solo
          label="ค้นหา..."
          v-model="Search_data"
          @input="searchProcess()"
          append-icon="search"
          style="margin-bottom: 0px;"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <!-- Create Button -->
      <v-flex md12 sm12 xs12  v-if="permission_edit == true || admin == 'true'">
        <v-tooltip top>
          <v-btn slot="activator" color="primary" dark fixed bottom right fab @click="add()">
            <v-icon>fa-plus</v-icon>
          </v-btn>
          <span>{{$t('create')}}</span>
        </v-tooltip>
      </v-flex>
      <v-layout
        row
        align-center
        text-xs-center
        style="margin-top:5rem;margin-bottom:15rem"
        v-if="table_data.length == 0 && !showLoading"
      >
        <v-flex xs12 md4 offset-md4 lg2 offset-lg5 class="adddoc-hover" style="cursor: pointer"  v-if="permission_edit == true || admin == 'true'">
          <v-tooltip top>
            <template slot="activator">
              <div @click="add()" style="padding-top:40px;padding-bottom:40px;">
                <v-icon style="font-size:80px;" color="blue">fa fa-plus</v-icon>
                <h3 class="headline mb-0" style="color:#2195F3;">{{$t('AddDocumentExpensed')}}</h3>
              </div>
            </template>
            <span>{{$t('create')}}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
      <!-- List -->
      <v-flex md12 sm12 xs12>
        <v-layout row wrap v-if="!showLoading">
          <v-flex lg6 md6 sm12 xs12 pa-1 v-for="(item, index) in table_data" :key="index">
             <v-card class="coco-box-shadow" style="border-left:5px solid #E3624E;border-radius:5px;">
              <v-layout row wrap class="coco-list-layout" pa-3>
                <v-flex lg1 md1 sm1 xs2 text-xs-center style="margin:auto">
                      <v-icon :size="50" style="color:#E3624E;"> fas fa-file-invoice-dollar</v-icon>
                    </v-flex>
                <v-flex lg8 md8 sm8 xs7 text-xs-left style="padding-left:15px;">
                  <v-layout row wrap style="color:rgba(0,0,0,0.54)">
                    <v-flex xs12>
                      <v-layout row wrap>
                        <v-flex lg5 md4 sm4 xs12>
                          <strong>{{$t('DocumentID')}} : </strong>
                        </v-flex>
                        <v-flex lg6 md7 sm6 xs12 style="margin-left:5px;">
                          <span>{{item.code}}</span>
                        </v-flex>
                        <v-flex lg5 md6 sm4 xs12>
                          <strong>{{$t('Document creation date')}} : </strong>
                        </v-flex>
                        <v-flex lg6 md4 sm6 xs12 style="margin-left:5px;">
                          <span>{{formatdate(item.date)}}</span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <!-- <v-flex xs12>
                      <v-layout row wrap>
                        <v-flex md6 sm12 xs12>
                          <span class="coco-list-label-text">วันที่มีผล :</span>
                          <span>{{formatdate(item.date)}}</span>
                        </v-flex>
                      </v-layout>
                    </v-flex>-->
                    <v-flex xs12>
                      <v-layout row wrap>
                         <v-flex lg5 md6 sm4 xs12>
                            <strong>{{$t('Document creator')}} : </strong>
                          </v-flex>
                          <v-flex lg6 md4 sm6 xs12 style="margin-left:5px;">
                            <span>{{item.creator_code}}</span>
                          </v-flex>
                          <v-flex lg12 md12 sm12 xs12 v-if="item.remark != ''">
                            <v-icon>info</v-icon>
                            <span>  {{item.remark}}</span>
                          </v-flex>
                          <v-flex lg12  md12 sm12 xs12 v-if="item.remark == ''">
                            <v-icon>info</v-icon>
                            <span>  -</span>
                          </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex lg1 md1 sm1 xs2>
                  <v-layout row wrap>
                    <v-flex lg1 md2 sm2 xs2 text-xs-right  >
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-menu offset-y>
                              <template  slot="activator" >
                                <v-btn icon style="color:rgba(0,0,0,0.54)">
                                  <v-icon >fas fa-ellipsis-v</v-icon>
                                </v-btn> 
                              </template>
                              <v-card class="pa-0" max-width="344">
                                  <v-card-title class="setbox"> 
                                    <v-btn color="orange" slot="activator" flat @click="viewdetail(item.code)">
                                      <v-icon>search</v-icon>
                                      <span>  {{$t('view')}}</span>
                                    </v-btn>
                                  </v-card-title>
                                  <v-card-title  class="setbox" v-if="permission_edit == true || admin == 'true'">
                                      <v-btn color="red" flat @click="deleteItem(item.code)">
                                        <v-icon>delete</v-icon>
                                        <span>  {{$t('delete')}}</span>
                                      </v-btn>
                                  </v-card-title>
                              </v-card>
                          </v-menu>
                       </v-card-actions>
                      </v-flex>
<!-- 
                    <v-flex md12 sm12 xs12 text-xs-center>
                      <v-layout row wrap>
                        <v-flex offset-lg5 offset-md3  offset-sm6 offset-xs8 lg3 md4 sm3 xs2  v-if="check_permission == true || admin == 'true'">
                          <v-btn
                            color="orange"
                            slot="activator"
                            icon
                            flat
                            @click="viewdetail(item.code)"
                          >
                            <v-icon>search</v-icon>
                          </v-btn>
                        </v-flex>
                        <v-flex lg3 md4 sm3 xs2  v-if="check_permission == true || admin == 'true'">
                          <v-btn color="red" icon flat @click="deleteItem(item.code)">
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex> -->
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- pagination -->
       <v-layout row wrap my-2>
      <v-flex xs12 >
        <div class="show_pagination_fixed" >
          <v-pagination fixed v-model="pageActive" :length="totalPages" :total-visible="7" circle  @input="getExpensesList('List')"></v-pagination>
        </div>
      </v-flex>
    </v-layout>
      <!-- Delete Dialog -->
      <v-flex md12 sm12 xs12>
        <delete-dialog
          :json_data="delete_dialog_data"
          v-on:close-dialog="onCloseDeleteDialog"
          v-on:delete-item="onDeleteDocument"
        />
      </v-flex>
      <!---new dialog------>
      <v-dialog
        v-model="dialog1"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        scrollable
      >
        <v-card tile>
          <v-toolbar card dark color="primary">
            <v-btn icon dark @click="dialog1 = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>{{form_dialog.code }} ({{formatdate(form_dialog.date)}})</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex md2 sm6 xs12>
                  <v-text-field
                    :label="$t('DocumentID')"
                    v-model="form_dialog.code"
                    required
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex md1 sm1 xs1></v-flex>
                <v-flex md2 sm6 xs12>
                  <v-text-field
                    :label="$t('Document creation date')"
                    v-model="form_dialog.date"
                    required
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex md1 sm1 xs1></v-flex>
                <v-flex md6 sm6 xs12>
                  <v-text-field :label="$t('remark')" v-model="form_dialog.remark" required></v-text-field>
                </v-flex>
              </v-layout>
              <v-flex md12 sm12 xs12 v-for="(item, index) in details" :key="index" @click="''">
                <v-card class="coco-box-shadow coco-list-hover">
                  <v-layout
                    align-center
                    justify-center
                    row
                    fill-height
                    wrap
                    class="coco-list-layout"
                  >
                    <v-flex lg1 md1 sm2 xs3 text-xs-center>
                      <v-avatar :size="64">
                        <v-avatar
                          v-if="item.emp_images == '' || item.emp_images == undefined  || item.emp_images == null"
                          :size="64"
                          color="teal"
                        >
                          <span class="white--text headline">{{item.nick_name}}</span>
                        </v-avatar>

                        <Empimage
                          v-if="item.emp_images != '' && item.emp_images != undefined  && item.emp_images != null"
                          :json_data="item.emp_images"
                        />
                      </v-avatar>
                    </v-flex>
                    <v-flex lg9 md9 sm8 xs9>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <span
                            class="coco-list-label-text"
                          >{{isEmpty(item.emp_code)? item.emp_code : 'emp_code'}}:</span>
                          <span>{{item.first_name}} {{item.last_name}}</span>
                        </v-flex>
                        <v-flex xs12 class="hidden-xs-only">
                          <span class="coco-list-label-text hidden-sm-only">
                            {{$t('branch')}}:
                            <span>
                              {{isEmpty(item.branch)? item.branch
                              : 'branch'}}
                            </span>
                          </span>
                          <span class="coco-list-label-text hidden-sm-only">
                            {{$t('Department')}}:
                            <span>
                              {{isEmpty(item.department_name) ?
                              item.department_name : 'department_name'}}
                            </span>
                          </span>
                          <span class="coco-list-label-text hidden-sm-only">
                            {{$t('Position')}}:
                            <span>
                              {{isEmpty(item.position) ?
                              item.position : 'position'}}
                            </span>
                          </span>
                          <span class="coco-list-label-icon">
                            <v-icon>access_time</v-icon>
                            <span>{{formatdate(item.effect_date)}}</span>
                          </span>
                          <span class="coco-list-label-icon">
                            <v-icon>monetization_on</v-icon>
                            <span
                              v-show="currencySymbols == '0'"
                            >{{symbolStyles + ' ' + formatNumber(item.amount, 2,true)}}</span>
                            <span
                              v-show="currencySymbols == '1'"
                            >{{formatNumber(item.amount, 2, true) + ' ' + symbolStyles}}</span>
                          </span>
                          <span class="coco-list-label-icon">
                            <v-icon>info</v-icon>
                            <span>{{isEmpty(item.name) ? item.name : '-'}}</span>
                          </span>
                        </v-flex>
                        <v-flex xs12 class="hidden-sm-and-up">
                          <span class="coco-list-label-icon">
                            <v-icon style="padding-left: 0px;">access_time</v-icon>
                            <span>{{formatdate(item.effect_date)}}</span>
                          </span>
                          <span class="coco-list-label-icon">
                            <v-icon>monetization_on</v-icon>
                            <span
                              v-show="currencySymbols == '0'"
                            >{{symbolStyles + ' ' + formatNumber(item.amount, 2, true)}}</span>
                            <span
                              v-show="currencySymbols == '1'"
                            >{{formatNumber(item.amount, 2, true) + ' ' + symbolStyles}}</span>
                          </span>
                        </v-flex>
                        <v-flex xs12 class="hidden-sm-and-up">
                          <span class="coco-list-label-icon">
                            <v-icon style="padding-left: 0px;">info</v-icon>
                            <span>{{isEmpty(item.name) ? item.name : '-'}}</span>
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex lg2 md2 sm2 xs2>
                      <v-layout row wrap>
                        <v-flex md12 sm12 xs12 text-xs-center>
                          <v-layout row wrap>
                            <v-flex offset-lg5 offset-md3 lg3 md4 xs6 >
                              <v-tooltip bottom>
                                <v-btn
                                  slot="activator"
                                  color="warning"
                                  icon
                                  flat
                                  @click="EditItem(item,index)"
                                >
                                  <v-icon>edit</v-icon>
                                </v-btn>
                                <span>{{$t('edit')}}</span>
                              </v-tooltip>
                            </v-flex>
                            <v-flex lg3 md4 xs6 >
                              <v-tooltip bottom>
                                <v-btn
                                  slot="activator"
                                  color="error"
                                  icon
                                  flat
                                  @click="deleteItemlistemp(item,index)"
                                >
                                  <v-icon>delete</v-icon>
                                </v-btn>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex xs12 text-xs-right>
                <v-btn color="blue darken-1" flat @click="dialog1 = false">{{$t('close')}}</v-btn>
                <v-btn color="blue darken-1" flat @click="dialog1 = false;onSave()">{{$t('save')}}</v-btn>
              </v-flex>
            </v-container>
          </v-card-text>
          <div style="flex: 1 1 auto;"></div>
        </v-card>
      </v-dialog>
      <!-- FormEdit -->
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span
                class="headline"
              >{{form_editdialog.emp_code}} : {{form_editdialog.first_name}}&nbsp;{{form_editdialog.last_name}}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-text-field :label="$t('name')" v-model="form_editdialog.name" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field :label="$t('amount')" v-model="form_editdialog.amount" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field label="วันที่มีผล" v-model="form_editdialog.effect_date" required></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="dialog = false">{{$t('close')}}</v-btn>
              <v-btn color="blue darken-1" flat @click="dialog = false;onUpdate()">{{$t('update')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <!--  delete -->
      <v-layout row justify-center>
        <v-dialog v-model="deldialog" persistent max-width="300px">
          <v-toolbar color="red">DELETE</v-toolbar>
          <v-card>
            <v-card-title>
              <span text-xs-center>{{$t("question.delete")}}</span>
              <br />
              <span
                text-xs-center
              >{{form_deldialog.emp_code}}:{{form_deldialog.first_name}}{{form_deldialog.last_name}}</span>
            </v-card-title>
            <v-card-text></v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="deldialog = false">Close</v-btn>
              <v-btn color="blue darken-1" flat @click="deldialog = false;onDeleteEmp()">delete</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <!-- Snackbar -->
      <v-snackbar
        v-model="snack_model.status"
        :timeout="3500"
        :top="'top'"
        :color="snack_model.type"
      >
        {{ snack_model.msg }}
        <v-btn dark flat icon @click="snack_model.status = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions, mapMutations } from "vuex";
import DocumentService from "@/services/DocumentService";
import Empimage from "../../components/getempimage.vue";
import DeleteDialog from "../../components/master/dialogs/DeleteDialog";
import Utils from "@/utils/";
import moment from "moment";
import $ from "jquery";
import FilterComponent from "./Filter";
import UserService from "@/services/UserService";
export default {
  data: () => ({
    Search_data: "",
    show_search: false,
    timeout: null,
    dialog: false,
    dialog1: false,
    index: "",
    form_dialog_data: {
      status: false,
     
    },
    delete_dialog_data: {
      status: false
    },
    snack_model: {
      status: "",
      msg: "",
      type: ""
    },
    form_dialog: {
      code: "",
      date: "",
      remark: "",
      create_date_time: "",
      last_update_time: "",
      creator_code: ""
    },
    form_editdialog: {
      code: "",
      name: "",
      amount: ""
    },
    form_deldialog: {
      amount: "",
      name: "",
      emp_code: "",
      detailincome: "",
      effect_date: ""
    },
    table_data: [],
    deldialog: false,
    details: [],
    pageActive: 1,
    totalPages:0,
    processing: false,
    canLoadMore: true,
    documentid: "",
    permission_edit:false,
    permission_view:false,
    admin:false,
    empCode: localStorage._empcode,
    permission:[]
  }),
  created:async function() {
    await  UserService.getpermissionByusercode(this.empCode)
    .then(res=>{
      this.permission = res.data.permission;
      console.log(res)
    })
     .catch(err => {});
    await this.checkpermission("ImportFileExpensed");
    console.log(this.check_permission);
     this.admin = localStorage._is_admin;
    // this.setShowFilter({
    //   status: 1
    // });
    this.commitSetToolbar({
      patternTool: "0"
    });
    this.getExpensesList("Form");

    // this.$store.watch(
    //   state => {
    //     state.filter.SelectBranch;
    //     state.filter.SelectDepartment;
    //     state.filter.SelectPosition;
    //     state.filter.SearchData;
    //     state.filter.FromDate;
    //     state.filter.ToDate;
    //   },
    //   () => {
    //     this.pageActive = 1;
    //     this.table_data = [];
    //     this.canLoadMore = true;
    //     this.getExpensesList("Filter");
    //   },
    //   {
    //     deep: true
    //   }
    // );
  },
  destroyed: function() {
    this.commitToggleAlertDialog({
      status: false,
      message: Object
    });
  },
  components: {
    Empimage,
    DeleteDialog,
    FilterComponent
  },
  computed: {
    ...mapState("filter", [
      "SelectBranch",
      "SelectDepartment",
      "SelectPosition",
      "SearchData",
      "FromDate",
      "ToDate"
    ]),
    ...mapState("app", [
      "showLoading",
      "formatDates",
      "symbolStyles",
      "currencySymbols"
    ]),
      //...mapState("permissionmenu", ["permission_List"]),
  },
  methods: {
    ...mapMutations("filter", ["setShowFilter"]),
    ...mapActions("app", ["commitSetToolbar", "commitSetShowLoading"]),
    ...mapActions("alert", ["commitToggleAlertDialog"]),
    goto(path) {
      this.$router.push("/" + path);
    },
    add() {
      this.goto("ImportFile/ImportFileExpensed");
    },
     checkpermission(page){
        let checkEdit = false
        let checkView = false
        if(this.permission.length != 0){
             this.permission.forEach(element => {
                 if(page == element.module_name){
                    checkEdit = element.edit;
                    checkView = element.reads;
                 }
             });
        }
        else{
            checkEdit = false;
            checkView = false;
        }
        this.permission_edit = checkEdit
        this.permission_view = checkView
    },
    formatNumber(value, digit, hasComma) {
      return Utils.formatNumber(value, digit, hasComma);
    },
    onCloseDialog() {
      this.pageActive = 1;
      this.table_data = [];
      this.form_dialog_data.status = false;
      this.getExpensesList();
    },
    onCloseDeleteDialog() {
      this.delete_dialog_data.status = false;
    },
    onHandleDialog(status, save_type, data) {
      this.form_dialog_data = {
        status: status,
        save_type: save_type,
        data: data
      };
    },
    isEmpty(value) {
      return Utils.isEmpty(value);
    },

    formatdate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
     searchProcess() {
      var v = this;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        v.getExpensesList("Filter");
      }, 1500);
    },
    searchClick() {
      if (this.show_search) {
        this.show_search = false;
          $('#pagetitleshow').removeClass('showtitlepage')
      } else {
        this.show_search = true;
          $('#pagetitleshow').addClass('showtitlepage')
      }
     },
    onScrollFunction(e) {
      let win_scroll_top = e.target.defaultView.pageYOffset;
      let win_height = window.innerHeight;
      let doc_height = document.body.scrollHeight;

      //console.log("win_scroll_top " + win_scroll_top);
      let width = $(".contain_width").width();
      //console.log("width " + width);
      if (win_scroll_top > 100) {
        $(".search_in_page").show();
        $(".search_in_page").css("width", width);
      } else {
        $(".search_in_page").hide();
      }
      /* if (win_scroll_top >= (doc_height - win_height) * 0.99) {
        if (!this.processing && this.canLoadMore) {
          this.pageActive += 1;
          //this.getEmployeeList('List');
          console.log('last');
        }
        if(this.processing && this.canLoadMore){
          console.log('not last');
        }
       }*/
    },
    showSnackBar(msg, type) {
      this.snack_model.msg = msg;
      this.snack_model.type = type;
      this.snack_model.status = true;
    },
    viewdetail(docno) {
      this.dialog1 = true;
      this.docno = docno;
      console.log("docno : ", docno);
      DocumentService.getExpensesByCode(docno)
        .then(res => {
          this.dialog1 = true;
          this.form_dialog = res.data;
          console.log("data: ", res.data);

          DocumentService.CheckDetail(this.form_dialog.details)
            .then(res => {
              this.details = res.data;
              console.log("checkdetaill: ", res.data);
              console.log("details : ", this.details);
            })
            .catch(err => {
              this.snack_model.status = true;
              this.snack_model.msg = "ไม่พบข้อมูล";
              this.snack_model.type = "error";
            });
        })
        .catch(err => {
          console.log(err);
        });
    },
    deleteItem(code) {
      this.delete_dialog_data.status = true;
      let message = "<p>" + this.$t("question.delete") + " " + code;

      ("?</p>");
      this.delete_dialog_data.message = message;
      this.delete_dialog_data.code = code;
    },
    onDeleteDocument() {
      console.log("onDeleteDocument data: ", this.delete_dialog_data.code);
      DocumentService.deleteExpenses(this.delete_dialog_data.code)
        .then(res => {
          this.showSnackBar(this.$t("message.delete"), "success");
          this.pageActive = 1;
          this.table_data = [];
          this.getExpensesList();
          this.delete_dialog_data.status = false;
        })
        .catch(err => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data
          });
        });
    },
    onDelete() {
      DocumentService.deleteExpenses(this.delete_dialog_data.code)
        .then(res => {
          this.snack_model.status = true;
          this.snack_model.msg = this.$t("message.delete");
          this.snack_model.type = "success";
          this.pageActive = 1;
          this.table_data = [];
          this.getExpensesList();
          this.delete_dialog_data.status = false;
        })
        .catch(err => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data
          });
        });
    },
    onCloseFormDialog(value) {
      this.form_dialog_data.status = false;
      this.onload = true;
      console.log("5555",this.FromDate)
      console.log("666",this.ToDate)
      this.getExpensesList("Form");
    },
    getExpensesList(Action) {
      this.commitSetShowLoading(true);
        this.table_data =[];
      DocumentService.getExpensesList(
        this.Search_data,
        this.pageActive,
        this.FromDate,
        this.ToDate
      )
        .then(res => {
          console.log(res);
          if (this.table_data.length > 0 && Action =="List") {
            if (res.data.content.length > 0) {
              res.data.content.forEach(data => {
                this.table_data.push(data);
              });
               this.totalPages = res.data.totalPages;
            } else {
              this.canLoadMore = false;
            }
          } else {
            this.table_data = res.data.content;
            this.totalPages = res.data.totalPages;
          }
        })
        .catch(err => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
    },
    onUpdate() {
      let v = this;
      (v.form_dialog.details[v.index].emp_code = v.form_editdialog.emp_code),
        (v.form_dialog.details[v.index].effect_date =
          v.form_editdialog.effect_date),
        (v.form_dialog.details[v.index].name = v.form_editdialog.name),
        (v.form_dialog.details[v.index].amount = v.form_editdialog.amount),
        // (v.table_data.detail[v.index].detailExpensed = v.form_editdialog.detailExpensed);
        (this.snack_model.status = true);
      this.snack_model.msg = this.$t("message.update");
      this.snack_model.type = "success";
      console.log("table_data : ", v.table_data);
    },
    EditItem(data, index) {
      this.dialog = true;
      this.form_editdialog = data;
      this.index = index;
      console.log("edititem: ", data);
      console.log("index: ", index);
    },
    onSave() {
      console.log("onsave: ", this.form_dialog);
      DocumentService.updateExpenses(this.form_dialog)
        .then(res => {
          console.log(res);
          this.snack_model.status = true;
          this.snack_model.msg = this.$t("message.save");
          this.snack_model.type = "success";
          //this.goto("ImportFile/ListExpensed");
          this.getExpensesList("Filter"); 
        })
        .catch(err => {
          this.snack_model.status = true;
          this.snack_model.msg = err;
          this.snack_model.type = "error";
        });
    },
    deleteItemlistemp(data, index) {
      this.deldialog = true;
      this.form_deldialog = data;
      console.log(this.form_deldialog);
      this.index = index;
    },
    onDeleteEmp() {
      console.log(this.index);
      this.details.splice(this.index, 1);
      this.form_dialog.details.splice(this.index, 1);
      console.log("ondelete: importexpensed", this.form_dialog);
    },
    showFilter(status){
      this.form_dialog_data = {
        status: status,
        data:1
      };
    },
  }
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Prompt");

span , strong{
  font-family: "Prompt", sans-serif;
}
.setbox{
padding: 0px !important;
text-align: left;
width: 100px;
}
.background {
  background: url("../../assets/banner1.png") no-repeat fixed top;
  }
</style>
